import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { CSVLink } from "react-csv";
import { api_host } from '../../../../../common/globals/constants';
import PortletContent from 'components/PortletContent';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Typography from '@material-ui/core/Typography';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment'
import compose from 'recompose/compose';
import 'moment/locale/es'  
import { withTranslation } from 'react-i18next';
moment.locale('es')

class Data extends Component {
    constructor(props) {
        super(props);
        this.translation = (this.props && this.props.t) ? this.props.t : (s => s);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            nameObjective: this.props.match.params.nombre_objetivo,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            data: null,
            dataTab: null,
            //value: ',',
            noMonCum: null,
            downCum: null,
            date: this.props.params.date,
            dateMoment: ((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            isRefresh: this.props.params.isRefresh,
            beginDate: null,
            endDate: null,
            arrayDataRow: null,
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.params.period !== prevState.time) {

            return {
                externalData: null,
                data:null,
                //prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                //isStatePeriod: nextProps.params.isStatePeriod
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                externalData: null,
                //prevObjectiveId: props.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh,          
            }

        } else if (nextProps.params.statePeriod !== prevState.statePeriod) {
            return {
                //prevObjectiveId: props.match.params.objetivo_id,
                data:null,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                rows: null,
                statePeriod: nextProps.params.statePeriod,
                isStatePeriod: nextProps.params.isStatePeriod
            }
        }
        return null;
    }


    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }

        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.params.isRefresh !== this.state.isRefresh) ||
            (prevProps.params.statePeriod !== this.state.statePeriod)) {                
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, step, isStepDowntime } = this.props.params
        const { history } = this.props;
        const {time} = this.state

        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        
        if (period === 'c') {
            fecha_inicio = moment(statePeriod.startDate).format('YYYY-MM-DD')
            fecha_inicio = fecha_inicio+' 00:00'
            fecha_termino = moment(statePeriod.endDate).add({"days":1}).format('YYYY-MM-DD')
            fecha_termino = fecha_termino+' 00:00'
            fetch(api_host + `/reporte/online/general/getDataCustom/?objetive=${objetivo_id}&inicio=${fecha_inicio}&termino=${fecha_termino}&user=${user}&period=${period}`)
            .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                'step',
                                period,
                                fecha_inicio,
                                fecha_termino)
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });
        } else {
            let finalTime = (moment().format('YYYY-MM-DD HH:mm'))
            let beginTime = (moment().subtract(1, "hours").format('YYYY-MM-DD HH:mm'))
            if (this.state.time === 'd') {
                beginTime = (moment().subtract(1, "days").format('YYYY-MM-DD HH:mm'))
            } else if (this.state.time === 'w') {
                beginTime = (moment().subtract(1, "weeks").format('YYYY-MM-DD HH:mm'))
            } else if (this.state.time === '3h') {
                beginTime = (moment().subtract(3, "hours").format('YYYY-MM-DD HH:mm'))
            } else if (this.state.time === '3d') {
                beginTime = (moment().subtract(3, "days").format('YYYY-MM-DD HH:mm'))
            }
            fetch(api_host + `/reporte/online/general/getDataCustom/?objetive=${objetivo_id}&inicio=${beginTime}&termino=${finalTime}&user=${user}&period=${time}`)
            .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);             
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                'step',
                                period,
                                beginTime,
                                finalTime)
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (data,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        step,
        period,
        fecha_inicio,
        fecha_termino) => {
            const t = this.translation
            const codigosOk = [0, 8, 9, 14, 17, 25, 26, 30, 200, 201, 204, 301, 302, 304, 307, 602, 1000]
            let arrayData = []
            let arrayDataTab = []
            let arrayDataRow = []

            Object.values(data['data_monitores']).forEach(key =>{                
                Object.values(key['data_monitor']).forEach(keyDataMonitor =>{
                    const fecha = keyDataMonitor['fecha'].substring(0, 10);
                    const hora = keyDataMonitor['fecha'].substring(11, 19);
                    
                    let dict = {};
                    var dictTab = {}
                    dict['servidor'] = key['monitor']
                    dict['fecha'] = keyDataMonitor['fecha'].substring(0,10)
                    dict['hora'] = keyDataMonitor['fecha'].substring(11,19)
                    dictTab['servidor'] = key['monitor']
                    dictTab['fecha'] = keyDataMonitor['fecha'].substring(0,10)
                    dictTab['hora'] = keyDataMonitor['fecha'].substring(11,19)
                    let cont = 0
                    let arrayStatus = []
                    let arrayResponse = []
                    Object.values(keyDataMonitor['data']).forEach(keyData =>{
                        let dictStatus = {}
                        let dictResponse = {}
                        cont = cont + 1
                        dict[keyData['nombre_paso']+' - estado '+cont] = keyData['estado']
                        dict[keyData['nombre_paso']+' - respuesta '+cont] = keyData['respuesta']
                        
                        dictStatus[keyData['nombre_paso']+' - estado '+cont] = keyData['estado']
                        dictResponse[keyData['nombre_paso']+' - respuesta '+cont] = keyData['respuesta']
                        arrayStatus.push(dictStatus)
                        arrayResponse.push(dictResponse)
                        
                        const arrayEstados = keyData['estado'][0].split(',')
                        const estado = arrayEstados.find(element => !codigosOk.includes(parseInt(element))) ? 'ERROR' : 'OK'
                        const newDict = {
                            [t('monitoring.tools-section.download-data.modal.data.csv.column.server')]: key['monitor'],
                            [t('monitoring.tools-section.download-data.modal.data.csv.column.date')] :fecha,
                            [t('monitoring.tools-section.download-data.modal.data.csv.column.time')]:hora,
                            [t('monitoring.tools-section.download-data.modal.data.csv.column.name')]: keyData['nombre_paso'],
                            [t('monitoring.tools-section.download-data.modal.data.csv.column.status')]: keyData['estado'][0],
                            [t('monitoring.tools-section.download-data.modal.data.csv.column.response-time')]: keyData['respuesta'],
                            [t('monitoring.tools-section.download-data.modal.data.csv.column.nok')]: estado,
                        }
                        arrayDataRow.push(newDict)
                    })
                    
                    arrayStatus.forEach(function(value, key){
                        dictTab[Object.entries(value)[0][0]] = Object.entries(value)[0][1] 
                    })
                    arrayResponse.forEach(function(value, key){
                        dictTab[Object.entries(value)[0][0]] = Object.entries(value)[0][1] 
                    })
                    arrayData.push(dict)
                    arrayDataTab.push(dictTab)
                })
            })
            

            this.setState({
                data: arrayData,
                dataTab: arrayDataTab,
                beginDate: fecha_inicio,
                endDate: fecha_termino,
                //noMonCum : noMonCumDate,
                //downCum : downCumDate,
                isLoading: false,
                //time: period,
                //step: step,
                dataError: false,
                arrayDataRow,
            }); 
       
    }

    handleChange = event => {
        this.setState({value: event.target.value});
      };

    render() {
        const { dataError, isLoading, data, noMonCum, downCum, dataTab, value, nameObjective, beginDate, endDate, arrayDataRow } = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' }; 
        const t = this.translation
        if (!dataError) {
            return (<FormattedChart handleChange={this.handleChange} value={value} 
                                    data={data} dataTab={dataTab} noMonCum={noMonCum} downCum={downCum} 
                                    isLoading={isLoading} style={style} styleHidden={styleHidden} 
                                    nameObjective={nameObjective} beginDate={beginDate} endDate={endDate}
                                    arrayDataRow={arrayDataRow}
                                    t={t}
                                    />) 
        }
        else if (dataError) {
            return (<p>No hay datos..</p>)
        }
        else return (<p> Error!</p >)

    }
}

function FormattedChart(props) {
    const t = props.t
    return (
        <div>
            { props.data == null  ? 
                <PortletContent>
                    <PerfectScrollbar>

                        <Typography
                        variant="h5"
                        >
                        <CircularProgress
                        variant="indeterminate"

                        size={24}
                        thickness={4}
                        
                        />
                        <br/>
                        {t('text.loading')}
                    </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            :
                <div style={{ maxWidth: "100%" }}>
                    <Table>
                        <TableRow>
                            <TableCell style={{borderBottom: "none"}}>
                                <Typography
                                    variant="h6"
                                >
                                    {t('monitoring.tools-section.download-data.modal.data.form.character-set.label')}
                                </Typography>
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <FormControl>
                                    <NativeSelect
                                        defaultValue={1}
                                        inputProps={{
                                            name: 'name',
                                            id: 'uncontrolled-native',
                                        }}
                                    >
                                        <option value={1}>{t('monitoring.tools-section.download-data.modal.data.form.character-set.option.utf8')}</option>                                        
                                    </NativeSelect>
                                </FormControl> 
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{borderBottom: "none"}}>
                                <Typography ariant="h6">{t('monitoring.tools-section.download-data.modal.data.form.separator-set.label')}</Typography>
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <FormControl component="fieldset">                                    
                                    <RadioGroup defaultValue={","} aria-label="gender" name="customized-radios"  onClick={props.handleChange}>
                                        <FormControlLabel value="," control={<Radio />} label={t('monitoring.tools-section.download-data.modal.data.form.separator-set.option.coma')} />
                                        <FormControlLabel value=";" control={<Radio />} label={t('monitoring.tools-section.download-data.modal.data.form.separator-set.option.semicolon')} />                                   
                                    </RadioGroup>
                                </FormControl>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{borderBottom: "none"}}>
                                <CSVLink data={props.data} separator={props.value} filename={props.nameObjective+"("+props.beginDate+" a "+props.endDate+").csv"}>
                                    <Button variant="contained" color="primary" size="small">{t('monitoring.tools-section.download-data.modal.data.form.button.download-csv')}</Button>
                                </CSVLink>                                
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <CSVLink data={props.dataTab} separator={props.value} filename={props.nameObjective+"("+props.beginDate+" a "+props.endDate+")tabulado.csv"}> 
                                    <Button variant="contained" color="primary" size="small">{t('monitoring.tools-section.download-data.modal.data.form.button.download-csv-tab')}</Button>
                                </CSVLink>
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <CSVLink data={props.arrayDataRow} separator={props.value} filename={props.nameObjective+"("+props.beginDate+" a "+props.endDate+")row.csv"}> 
                                    <Button variant="contained" color="primary" size="small">{t('monitoring.tools-section.download-data.modal.data.form.button.download-csv-transposed')}</Button>
                                </CSVLink>
                            </TableCell>
                        </TableRow>            
                    </Table>
                </div>}
            </div>
        )

}


export default compose(
    withRouter,
    withTranslation()
)(Data);